import { inject, Injectable, } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CmsDataService } from './cms.service';

@Injectable({
    providedIn: 'root'
})
export class CeMarkContentResolver implements Resolve<any> {
    private cmsService = inject(CmsDataService);
    private router = inject(Router);
    private tag = "ce";

    resolve(): Observable<any> {
        return this.cmsService.getCmsProjectGroupByTag$(this.tag).pipe(
            catchError(() => this.router.navigateByUrl('/'))
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class FaqContentResolver implements Resolve<any> {
    private cmsService = inject(CmsDataService);
    private router = inject(Router);
    private tag = "faq";

    resolve(): Observable<any> {
        return this.cmsService.getCmsProjectGroupByTag$(this.tag).pipe(
            catchError(() => this.router.navigateByUrl('/'))
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class DataProcessingInfoContentResolver implements Resolve<any> {
    private cmsService = inject(CmsDataService);
    private router = inject(Router);
    private tag = "dataprocessing";

    resolve(): Observable<any> {
        return this.cmsService.getCmsProjectGroupByTag$(this.tag).pipe(
            catchError(() => this.router.navigateByUrl('/'))
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class CookiePolicyContentResolver implements Resolve<any> {
    private cmsService = inject(CmsDataService);
    private router = inject(Router);
    private tag = "cookiepolicy";

    resolve(): Observable<any> {
        return this.cmsService.getCmsProjectGroupByTag$(this.tag).pipe(
            catchError(() => this.router.navigateByUrl('/'))
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class PrivacyPolicyContentResolver implements Resolve<any> {
    private cmsService = inject(CmsDataService);
    private router = inject(Router);
    private tag = "privacypolicy";

    resolve(): Observable<any> {
        return this.cmsService.getCmsProjectGroupByTag$(this.tag).pipe(
            catchError(() => this.router.navigateByUrl('/'))
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientProfileContentResolver implements Resolve<any> {
    private cmsService = inject(CmsDataService);
    private router = inject(Router);
    private tag = "confirmdeletedata";

    resolve(): Observable<any> {
        return this.cmsService.getCmsProjectGroupByTag$(this.tag).pipe(
            catchError(() => this.router.navigateByUrl('/'))
        );
    }
}